import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { ScanIcon, UserIcon, SettingsIcon } from 'lucide-react';
interface User {
  id: string;
  name: string;
  role: string;
  company: string;
  tags: string[];
  goals: string;
  image: string;
}
interface HomeScreenProps {
  user: User;
}
export function HomeScreen({
  user
}: HomeScreenProps) {
  const [scanMode, setScanMode] = useState(false);
  const qrValue = JSON.stringify({
    id: user.id,
    name: user.name,
    company: user.company
  });
  return <div className="flex flex-col flex-1" data-id="element-129">
      <header className="p-4 flex items-center justify-between border-b" data-id="element-130">
        <div className="flex items-center gap-2" data-id="element-131">
          <div className="h-10 w-10 bg-indigo-600 rounded-full flex items-center justify-center text-white font-bold" data-id="element-132">
            S
          </div>
          <h1 className="text-xl font-bold text-indigo-600" data-id="element-133">ScanShake</h1>
        </div>
        <div className="flex gap-3" data-id="element-134">
          <button className="p-2 rounded-full hover:bg-gray-100" data-id="element-135">
            <SettingsIcon size={20} className="text-gray-600" data-id="element-136" />
          </button>
          <button className="p-2 rounded-full hover:bg-gray-100" data-id="element-137">
            <UserIcon size={20} className="text-gray-600" data-id="element-138" />
          </button>
        </div>
      </header>
      <div className="flex-1 flex flex-col items-center justify-center p-6" data-id="element-139">
        {!scanMode ? <>
            <div className="text-center mb-6" data-id="element-140">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-141">
                Your ScanShake QR
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-142">
                Have others scan to connect instantly
              </p>
            </div>
            <div className="bg-white p-4 rounded-2xl shadow-md mb-6" data-id="element-143">
              <QRCodeSVG value={qrValue} size={250} bgColor={'#ffffff'} fgColor={'#4f46e5'} level={'H'} includeMargin={false} data-id="element-144" />
            </div>
            <div className="flex flex-col items-center" data-id="element-145">
              <div className="flex items-center gap-3 mb-3" data-id="element-146">
                <img src={user.image} alt={user.name} className="w-10 h-10 rounded-full object-cover" data-id="element-147" />
                <div data-id="element-148">
                  <h3 className="font-semibold" data-id="element-149">{user.name}</h3>
                  <p className="text-sm text-gray-500" data-id="element-150">
                    {user.role} at {user.company}
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 justify-center max-w-xs" data-id="element-151">
                {user.tags.map((tag, index) => <span key={index} className="bg-indigo-100 text-indigo-800 text-xs px-2 py-1 rounded-full" data-id="element-152">
                    {tag}
                  </span>)}
              </div>
            </div>
          </> : <div className="flex flex-col items-center justify-center h-full" data-id="element-153">
            <div className="relative w-64 h-64 mb-6" data-id="element-154">
              <div className="absolute inset-0 border-2 border-indigo-500 rounded-lg" data-id="element-155"></div>
              <div className="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-indigo-600 rounded-tl-lg" data-id="element-156"></div>
              <div className="absolute top-0 right-0 w-10 h-10 border-t-2 border-r-2 border-indigo-600 rounded-tr-lg" data-id="element-157"></div>
              <div className="absolute bottom-0 left-0 w-10 h-10 border-b-2 border-l-2 border-indigo-600 rounded-bl-lg" data-id="element-158"></div>
              <div className="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-indigo-600 rounded-br-lg" data-id="element-159"></div>
            </div>
            <p className="text-gray-500 text-center mb-6" data-id="element-160">
              Position QR code in the frame
            </p>
          </div>}
      </div>
      <div className="p-6 flex justify-center" data-id="element-161">
        <button onClick={() => setScanMode(!scanMode)} className="bg-indigo-600 text-white px-6 py-3 rounded-full flex items-center gap-2 shadow-lg hover:bg-indigo-700 transition-colors" data-id="element-162">
          <ScanIcon size={20} data-id="element-163" />
          {scanMode ? 'Show My QR' : 'Scan QR Code'}
        </button>
      </div>
    </div>;
}